import {
  GET_CHAT,
  SET_CHAT,
  Chat,
  SendMessageProps,
  SEND_MESSAGE,
  GET_CHAT_DETAILS,
  SET_CHAT_DETAILS,
  SYNC_CHAT_DETAILS,
  ChatProps,
} from './types';

export const getChat = () => ({ type: GET_CHAT });

export const setChat = (chat: Chat[]) => ({ type: SET_CHAT, chat });

export const getChatDetails = () => ({ type: GET_CHAT_DETAILS });

export const setChatDetails = (chatDetails: ChatProps) => ({
  type: SET_CHAT_DETAILS,
  chatDetails,
});

export const getsyncChatDetails = () => ({ type: SYNC_CHAT_DETAILS });

export const sendMessage = (chat: SendMessageProps) => ({
  type: SEND_MESSAGE,
  chat,
});
